<template>
  <div class="collapsible-widget" role="tab">
    <div
      @click="expand(false)" 
      :class="{'collapsed': expanded}"
      class="collapsible-widget-button btn btn-success"
      :aria-controls="bodyId"
      :aria-expanded="expanded ? 'true' : 'false'">
        <b-checkbox 
          v-if="selectAllEnabled"
          class="float-left inline-custom-checkbox"
          @click.native.stop
          @change="onCheckboxChanged"
          :checked="allSelected"
          :indeterminate="indeterminate"
          v-b-tooltip="{ title: indeterminate || !allSelected ? 'Zaznacz wszystkie warstwy' : 'Odznacz wszystkie warstwy', placement: 'left', boundary: 'window', trigger: 'hover' }">
          </b-checkbox>
        <icon v-if="showBackgroundLayerError" name="exclamation-triangle" class="text-danger float-left blayer-error-icon" aria-hidden="true" title="Błąd wczytywania podkładów mapowych."></icon>
        <span class="float-left" :class="{ 'ml-4': !showBackgroundLayerError && !selectAllEnabled }">{{title}}</span>
        <icon class="float-right ml-1 collapsible-widget-expander-icon" :class="{ 'expanded': expanded }" name="caret-right"></icon>
      </div>
      <b-collapse visible class="collapsible-widget-body" :id="bodyId" v-model="expanded" :accordion="accordion" role="tabpanel" style="height: 100%;">
        <slot></slot>
      </b-collapse>
    </div>
</template>

<script>
export default {
  name: "CollapsibleWidget",
  props: {
    title: {
      type: String,
      required: true,
      default: ""
    },
    maxHeight: {
      type: Number,
      default: 100
    },
    minHeight: {
      type: Number,
      default: 0
    },
    flex: {
      type: String,
      default: '0 1 auto'
    },
    accordion: {
      type: String,
      default: 'panel'
    },
    defaultExpanded: {
      type: Boolean,
      default: false
    },
    expandWidget: {
      type: Boolean,
      default: false
    },
    selectAllEnabled: {
      type: Boolean,
      default: false
    },
    onCheckboxChanged: {
      type: Function,
      default: () => {}
    },
    allSelected: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    showBackgroundLayerError: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: false
    };
  },
  mounted() {
      this.expanded = this.defaultExpanded;
  },
  computed: {
    styleMaxHeight() {
      return this.maxHeight + "%";
    },
    styleMinHeight() {
      return this.minHeight + "%";
    },
    bodyId() {
      let hash = 0;

      if (this.title.length > 0) {
        for (let i = 0; i < this.title.length; ++i) {
          let char = this.title.charCodeAt(i);
          hash = (hash << 5) - hash + char;
          hash |= 0;
        }
      }

      return "collapsible-widget-body-" + hash;
    }
  },
  methods: {
    expand(isCompositionClick) {
      this.expanded = !this.expanded;
      this.$emit("toggled", { expanded: this.expanded, isCompositionClick: isCompositionClick });
    },
  },
  watch: {
    expandWidget(value) {
      this.expanded = value;
    }
  }
};
</script>

<style>
.collapsible-widget {
  -webkit-align-items: stretch;
  align-items: stretch;
}

.collapsible-widget-button{
  border-radius: 0;
  -webkit-flex: none;
  flex: none;
  white-space: normal;
  width:100%;
  cursor: pointer;
}

.collapsible-widget-body {
  background-color: rgba(255, 255, 255, 0.85);
  margin-bottom: 0;
  display: block;;
}

.inline-custom-checkbox {
  display: inline-block;
}

.collapsible-widget-expander-icon {
  transform: rotate(0);
  transition-property: transform;
  transition-duration: 250ms;
}

.collapsible-widget-expander-icon.expanded {
  transform: rotate(90deg);
  transition-property: transform;
  transition-duration: 250ms;
}
</style>
